import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiErrorCode, IErrorResponse } from '../../api/errors';
import { ReviewService } from '../../service/review.service';
import { userActions } from '../user/user.slice';

import {
  IComment,
  ICommentDataResponse,
  ICommentResponse,
  ILikes_info,
  IReview,
  IReviewComment,
  IReviewCommentResponse,
  IReviewLike,
} from './review.interface';

export const getReview = createAsyncThunk<
  IReviewCommentResponse,
  IReviewComment
>(
  'fetch/get-review',
  async ({ owner_id, owner_type, limit, offset }, thunkAPI) => {
    try {
      const response = await ReviewService.getByCardComment({
        owner_id,
        owner_type,
        limit,
        offset,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addReview = createAsyncThunk<
  { review_comment_id: number },
  IReview
>(
  'fetch/add-review',
  async ({ owner_id, owner_type, stars, content }, thunkAPI) => {
    try {
      const response = await ReviewService.addReview({
        owner_id,
        owner_type,
        stars,
        content,
      });

      if (
        // @ts-ignore
        response.data?.error_code ===
        ApiErrorCode.authorization_required_with_login_password
      ) {
        thunkAPI.dispatch(userActions.setAuthVisible(true));
      }
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addComment = createAsyncThunk<ICommentResponse, IComment>(
  'fetch/add-comment',
  async ({ comment_id, content }, thunkAPI) => {
    try {
      const response = await ReviewService.addComment(comment_id, content);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

/*
export const setLikeReview = createAsyncThunk<
  IErrorResponse & ILikes_info,
  IReviewLike
>('fetch/set-like', async ({ comment_id, is_like }, thunkAPI) => {
  try {
    const response = await ReviewService.setLikeOrDislike(comment_id, is_like);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
*/
